<div class="title_div">
  
  <div class="w-100 d-flex justify-content-between align-items-center">
    <div class="title_sub_div_1 mt-1">Overview</div>
    <div class="title_sub_div_1 mt-1 mr-1">
      <i class="fa fa-home" (click)="home()" title="Dashboard"></i> <!-- Home icon here -->
    </div>
  </div>
</div>

<div>
  <div class="d-flex justify-content-start">
    <div class="form-group">
    
      <select id="customerName" class="form-select form-select-lg" aria-label="Select Customer Name"
        [(ngModel)]="selectedCustomerName" (change)="onSelectCustomer()">
        <option disabled value="" [selected]="selectedCustomerName === ''">Customer </option>
        <option *ngFor="let cus of allCustomerData" [value]="cus.customerName">{{ cus.customerName }}</option>
      </select>
    </div>
  
    <div class="form-group">
     
      <select id="customerName" class="form-select form-select-lg" aria-label="Select Stage"
        [(ngModel)]="selectedCurrentStage" (change)="onSelectStage($event)">
        <option disabled value="" [selected]="selectedCurrentStage === ''">Stage</option>
        <option value="Costing" [selected]="selectedCurrentStage === 'Costing'">Costing</option>
        <option value="Procurement" [selected]="selectedCurrentStage === 'Procurement'">Procurement</option>
        <!-- <option *ngFor="let cus of allCustomerData" [value]="cus.currentStage">{{ cus.currentStage }}</option> -->
      </select>
    </div>

    
    <!-- Button to trigger the ECD modal -->
    <button type="button" class="btn btn-outline-primary btn-sm form-group" style="background-color: white;"
      (click)="openModalECD()">ECD Date</button>

    <!-- ECD Modal Popup -->
    <div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show': showModalECD}"
      [ngStyle]="{'display': showModalECD ? 'block' : 'none'}">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Expected Completion Date </h5>
            <button type="button" class="close" (click)="closeModalECD()">
              <span aria-hidden="true" style="font-size: 2rem;" >&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group" title="Expected Completion Date">
              <div style="display: flex; gap: 10px; flex-wrap: wrap;">
                <div>
                  <label for="fromExpectedCompletionDate">From</label>

                  <input id="fromExpectedCompletionDate" class="custom-date" type="date"
                    aria-label="Select Start Expected Completion Date" [(ngModel)]="fromExpectedCompletionDate"
                    (change)="onSelectCompletionDate()" />
                </div>
                <div>
                  <label for="toExpectedCompletionDate">To</label>
                  <input id="toExpectedCompletionDate" class="custom-date" type="date"
                    aria-label="Select End Expected Completion Date" [(ngModel)]="toExpectedCompletionDate"
                    (change)="onSelectCompletionDate()" />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- Reset Button -->
            <button type="button" class="btn btn-outline-primary btn-sm form-group"
              (click)="resetDates()">Reset</button>
            <button type="button" class="btn btn-outline-primary btn-sm form-group"
              (click)="closeModalECD()">Close</button>
          </div>
        </div>
      </div>
    </div>



    <!-- Button to trigger the RFQ modal -->
    <button type="button" class="btn btn-outline-primary btn-sm form-group" style="background-color: white;"
      (click)="openModalRFQ()">RFQ Date
    </button>

    <!-- RFQ Date Range Modal Popup -->
    <div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show': showModalRFQ}"
      [ngStyle]="{'display': showModalRFQ ? 'block' : 'none'}">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">RFQ Date</h5>
            <button type="button" class="close" (click)="closeModalRFQ()">
              <span aria-hidden="true" style="font-size: 2rem;">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group" title="RFQ Date Range">
              <div style="display: flex; gap: 10px; flex-wrap: wrap;">
                <div>
                  <label for="fromRfqDate">From</label>
                  <input id="fromRfqDate" class="custom-date" type="date" aria-label="Select From RFQ Date"
                    [(ngModel)]="fromRfqDate" (change)="onDateRangeChange()" />
                </div>
                <div>
                  <label for="toRfqDate">To</label>
                  <input id="toRfqDate" class="custom-date" type="date" aria-label="Select To RFQ Date"
                    [(ngModel)]="toRfqDate" (change)="onDateRangeChange()" />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- Reset Button -->
            <button type="button" class="btn btn-outline-primary btn-sm form-group"
              (click)="resetRfqDates()">Reset</button>
            <button type="button" class="btn btn-outline-primary btn-sm form-group"
              (click)="closeModalRFQ()">Close</button>
          </div>
        </div>

      </div>

    </div>
    <button type="button" class="btn btn-outline-primary btn-sm"  style="background-color: white;" title="Reset fields"
      (click)="resetFields()">Reset</button>
  </div>
  <div class="d-flex justify-content-start">
    <div class="form-group card" (click)="onOpenClickedProject('Open')">
      <div class="custom-card-small custom-card-open-projects">
        <div class="custom-card-content-small">
          <div class="custom-card-number-small">{{openStatusCount || 0}}</div>
          <div class="custom-card-text-small">Open Projects</div>
        </div>
      </div>
    </div>
    <div class="form-group card" (click)="onOverdueClick()">
      <div class="custom-card-small custom-card-overdue">
        <div class="custom-card-content-small">
          <div class="custom-card-number-small">{{overdueCount || 0 }}</div>
          <div class="custom-card-text-small">Over Due</div>
        </div>
      </div>
    </div>
    <div class="form-group card">
      <div class="custom-card-small custom-card-yet-to-approved">
        <div class="custom-card-content-small">
          <div class="custom-card-number-small">2</div>
          <div class="custom-card-text-small">Yet To Approved</div>
        </div>
      </div>
    </div>
    <div class="form-group card">
      <div class="custom-card-small custom-card-high-risk-parts">
        <div class="custom-card-content-small">
          <div class="custom-card-number-small">10</div>
          <div class="custom-card-text-small">High Risk Parts</div>
        </div>
      </div>
    </div>
  </div>  

  <div class="row row_mar mt-1">
    <div class="col-12 grid-margin stretch-card col_pad">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive gd_main_div_mobile">
            <table class="table table-striped custom-hover">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Project Name</th>
                  <th>Customer Name</th>
                  <th>RFQ Date</th>
                  <th>Assigned To</th>
                  <th>Assigned Date</th>
                  <th>E.C.Date</th>
                  <th>Target L.Time(W)</th>
                  <th>Ageing</th>
                  <th>Progress</th>
                  <th>Status</th>
                  <th>Current Stage</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let customer of matchedCustomerData; let i = index">
                  <td>{{ i+1 }}</td>
                  <td class="projectName_td" (click)="onProjectNameClicked()">{{ customer.projectName }}</td>
                  <td>{{ customer.customer_name }}</td>
                  <td>{{ customer.rfqDate | date: 'dd-MM-yyyy' }}</td>
                  <td>{{ customer.assigned_to_name }}</td>
                 
                  <td>{{ customer.assigned_date | date: 'dd-MM-yyyy' }}</td>
                  <td>{{ customer.expectedCompletionDate | date: 'dd-MM-yyyy' }}</td>
                  <td>{{ customer.targetLeadTime }}</td>
                  <td>{{ customer.ageing }}</td>
                  <td>{{ customer.progress }}</td>
                  
                  <td>{{ customer.status }}</td>
                  <td>{{ customer.currentstage }}</td>
                 
                  <td>
                    {{ customer.version_id }}
                   
                  </td>
                
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #customerModal let-modal>
    <div class="modal-header">
      <div class="modal-title">Add Customer</div>h6>
    </div>
    <div>
      <!-- <div class="container"> -->
      <div class="row">
        <div class="column">
          <label for="firstName">Customer FullName</label>
          <input type="text" id="firstName" placeholder="Enter Full Name">
        </div>
        <div class="column">
          <label for="lastName">City</label>
          <input type="text" id="lastName" placeholder="Enter City">
        </div>
      </div>
      <div class="row">
        <div class="column">
          <label for="state">State</label>
          <input type="text" id="state" placeholder="Enter State">
        </div>
        <div class="column">
          <label for="zip">Country</label>
          <input type="text" id="zip" placeholder="Enter Country">
        </div>
      </div>
      <div class="row">
        <div class="column">
          <label for="state">GST Number</label>
          <input type="text" id="state" placeholder="Enter GST Number">
        </div>
        <div class="column">

        </div>
      </div>
      <!-- </div> -->

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-primary btn-sm" title="Save" (click)="saveCustomer()">Save</button>
      <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="closeModal()">Close</button>
    </div>
  </ng-template>
  <ng-template #projectModal let-modal>
    <div class="modal-header">
      <div class="modal-title">Add Project</div>h6>
    </div>
    <div>
      <!-- <div class="container"> -->
      <div class="row">
        <div class="column">
          <label for="firstName">New Project Name</label>
          <input type="text" id="firstName" placeholder="New Project Name">
        </div>
        <div class="column">
          <label for="lastName">Customer Name</label>
          <input type="text" id="lastName" placeholder="Customer Name">
        </div>
      </div>
      <div class="row">
        <div class="column">
          <label for="email">RFQ Date</label>
          <input type="email" id="email" placeholder="RFQ Date">
        </div>
        <div class="column">
          <label for="phone">Expected Completion Date</label>
          <input type="tel" id="phone" placeholder="Expected Completion Date">
        </div>
      </div>
      <div class="row">
        <div class="column">
          <label for="address">Target L. T</label>
          <input type="text" id="address" placeholder="Target L. T">
        </div>
        <div class="column">
          <label for="city"></label>
          <button type="button" class="btn btn-primary btn-sm ml-1" title="Landing Cost"
            (click)="onLandinCost(landinCostModal)">Landing Cost</button>
        </div>
      </div>
      <!-- </div> -->

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-primary btn-sm" title="Save" (click)="save()">Save</button>
      <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="closeModal()">Close</button>
    </div>
  </ng-template>
  <ng-template #landinCostModal let-modal>
    <div class="modal-header">
      <div class="modal-title">Landing Cost</div>h6>
    </div>
    <div class="modal-body">
      <!-- Q1 -->
      <div class="form-group">
        <label>
          Q-1: Do you want to calculate Landing cost for the project?
        </label>
        <div class="form-check">
          <input class="form-check-input" type="radio" id="q1Yes" checked name="q1" (click)="onQn1Change('yes')">
          <label class="form-check-label" for="q1Yes">Yes</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" id="q1No" name="q1" (click)="onQn1Change('no')">
          <label class="form-check-label" for="q1No">No</label>
        </div>
      </div>

      <!-- Q2 -->
      <div class="form-group" *ngIf="showQn2">
        <label>
          Q-2: Do you want to consider Duties for calculating landing cost?
        </label>
        <div class="form-check">
          <input class="form-check-input" type="radio" id="q2Yes" name="q2" (click)="onQn2Change('yes')">
          <label class="form-check-label" for="q2Yes">Yes</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" id="q2No" name="q2" (click)="onQn2Change('no')">
          <label class="form-check-label" for="q2No">No</label>
        </div>
      </div>

      <!-- Q3 -->
      <div class="form-group" *ngIf="showQn3">
        <label>
          Q-3: Is it for Export or for local consumption?
        </label>
        <select class="form-control" (change)="onQn3Change($event.target.value)">
          <option value="">Select</option>
          <option value="export">Export</option>
          <option value="local">Local Consumption</option>
        </select>
      </div>

      <!-- Q4 -->
      <div class="form-group" *ngIf="showQn4">
        <label>
          Q-4: Do you need specific duty to be added?
        </label>
        <div class="form-check">
          <input class="form-check-input" type="radio" id="q4Yes" name="q4" (click)="onQn4Change('yes')">
          <label class="form-check-label" for="q4Yes">Yes</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" id="q4No" name="q4" (click)="onQn4Change('no')">
          <label class="form-check-label" for="q4No">No</label>
        </div>
      </div>

      <!-- Q5 -->
      <div class="form-group" *ngIf="showQn5">
        <label>
          Q-5: Define your generic duty percentage to be considered
        </label>
        <input type="number" class="form-control" placeholder="Enter generic duty percentage">
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-primary btn-sm" title="Save"
        (click)="saveLandingCost()">Save</button>
      <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="closeModal()">Close</button>
    </div>
  </ng-template>

  <!-- </div> -->
  <ng-template #uploadFileModal let-modal>
    <div class="modal-header">
      <div class="modal-title">Upload Files</div>h6>
    </div>
    <div class="modal-body">
      <div class="main-div flex-wrap">
        <!-- Upload Sourcing List -->
        <div class="form-group modalformGroup">
          <label class="upladed_label_field">Upload Sourcing List</label>
          <div class="form-group input-group upladed_data_field">
            <input type="text" class="form-control" placeholder="Upload file" [value]="sourcingListFileName" readonly
              (click)="upload_input.click()">
            <div class="input-group-append" *ngIf="sourcingListFileName">
              <i class="mdi mdi-bookmark-remove icon_remove" aria-hidden="true" (click)="clearSourcingListFiles()"
                title="Remove files.">
              </i>
            </div>
            <input #upload_input type="file" class="file-input" hidden (change)="uploadSourcingListFiles($event)">
          </div>
          <button type="button" class="btn btn-outline-primary btn-sm mt-2" [disabled]="!sourcingListFileName"
            (click)="uploadSourcingListFiles()" title="Upload Files">
            Upload
          </button>
        </div>



        <div class="form-group modalformGroup">
          <label class="upladed_label_field">Upload Alternate Part List</label>
          <div class="form-group input-group upladed_data_field">
            <!-- Display the filename here -->
            <input type="text" class="form-control" placeholder="Upload file" formControlName="alternatePartFileName"
              readonly (click)="upload_avd_input.click()">

            <div class="input-group-append" *ngIf="avdListFileName">
              <i class="mdi mdi-bookmark-remove icon_remove" aria-hidden="true" (click)="clearAvdFiles()"
                title="Remove files.">
              </i>
            </div>

            <input #upload_avd_input type="file" class="file-input" hidden (change)="uploadAvdFiles($event)">
          </div>
          <button type="button" class="btn btn-outline-primary btn-sm mt-2" [disabled]="!avdListFileName"
            [disabled]="avdData.length === 0" (click)="uploadAvdFiles()" title="Upload Files">
            Upload
          </button>
        </div>


      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="finalData()">
        Compare Both File
      </button>
      <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="closeModal()">
        Close
      </button>
    </div>
  </ng-template>